import React from 'react';
import {
  formatRatingRange,
  formatRatingValue,
  RATING_POSITION_MAX,
  RATING_POSITION_MIN,
} from './leadFilters';

interface RatingRangeFieldProps {
  minPosition: number;
  maxPosition: number;
  onChange: (minPosition: number, maxPosition: number) => void;
}

const positions = Array.from(
  { length: RATING_POSITION_MAX - RATING_POSITION_MIN + 1 },
  (_, index) => index,
);

const RatingRangeField: React.FC<RatingRangeFieldProps> = ({
  minPosition,
  maxPosition,
  onChange,
}) => {
  const isDefault = minPosition === RATING_POSITION_MIN && maxPosition === RATING_POSITION_MAX;

  const setMinimum = (next: number) => onChange(Math.min(next, maxPosition), maxPosition);
  const setMaximum = (next: number) => onChange(minPosition, Math.max(next, minPosition));

  return (
    <div>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <h4 className="text-sm font-semibold text-gray-900">Google rating</h4>
          <p className="mt-1 text-xs text-gray-500">No rating is a separate option before 1.0.</p>
        </div>
        <span className="text-sm font-semibold text-[#8A3033]">
          {formatRatingRange(minPosition, maxPosition)}
        </span>
      </div>

      <div className="mt-4 flex flex-wrap items-end justify-between gap-3">
        <div className="grid w-full grid-cols-2 gap-3 sm:w-auto">
          <label className="text-xs font-semibold text-gray-600">
            Min
            <select
              value={minPosition}
              onChange={(event) => setMinimum(Number(event.target.value))}
              className="mt-1 block min-h-[44px] w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 focus:border-[#8A3033] focus:outline-none focus:ring-2 focus:ring-[#8A3033]/20 sm:w-40"
            >
              {positions.filter(position => position <= maxPosition).map(position => (
                <option key={position} value={position}>{formatRatingValue(position)}</option>
              ))}
            </select>
          </label>
          <label className="text-xs font-semibold text-gray-600">
            Max
            <select
              value={maxPosition}
              onChange={(event) => setMaximum(Number(event.target.value))}
              className="mt-1 block min-h-[44px] w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 focus:border-[#8A3033] focus:outline-none focus:ring-2 focus:ring-[#8A3033]/20 sm:w-40"
            >
              {positions.filter(position => position >= minPosition).map(position => (
                <option key={position} value={position}>{formatRatingValue(position)}</option>
              ))}
            </select>
          </label>
        </div>
        {!isDefault && (
          <button
            type="button"
            onClick={() => onChange(RATING_POSITION_MIN, RATING_POSITION_MAX)}
            className="min-h-[44px] text-sm font-semibold text-[#8A3033] underline underline-offset-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8A3033]"
          >
            Reset to any rating
          </button>
        )}
      </div>
    </div>
  );
};

export default RatingRangeField;
